import React, { useEffect, useState } from "react";
import {
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Tab,
  Box,
  Typography,
  Pagination,
  Modal,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Stack,
  alpha,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { tabsStyle, WEBSERVICE } from "../../CoreDataService";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import Skeleton from "@mui/material/Skeleton";
import { useSelector } from "react-redux";
import ActionTabs from "../../Common/ActionTabs";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import DataTable from "../../Common/DataTable";
import ActionButton from "../../Common/ActionButton";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import ShowChartOutlinedIcon from "@mui/icons-material/ShowChartOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";

const TabPanel = ({ children, value, index }) => {
  return (
    <div hidden={value !== index}>
      {value === index && <Box p={2}>{children}</Box>}
    </div>
  );
};

const modalStyle = {
  // position: "absolute",
  // top: "50%",
  // left: "50%",
  // transform: "translate(-50%, -50%)",
  // width: 450,
  // // bgcolor: "background.paper",
  // borderRadius: 2,
  // boxShadow: 24,
  // p: 4,
};

export default function HistoryPage() {
  const theme = localStorage.getItem("theme");
  const { btncolor, allColors, brokerMarkets } = useSelector((state) => state);
  const [modalOpen, setModalOpen] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);
  const [mainTab, setMainTab] = useState("spot");
  const [timeSpan, setTimeSpan] = useState("all");
  const FilterLabel = [
    { label: "All", value: "all" },
    { label: "Last Week", value: "last week" },
    { label: "Last Month", value: "last month" },
  ];

  const columns = [
    "Date - Time",
    "TXN ID",
    "Description",
    "Type",
    "Asset",
    "Status",
  ];

  // Spot state
  const [spotData, setSpotData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [pageNo, setPageNo] = useState(1);
  const [isSpotLoading, setIsSpotLoading] = useState(false);

  // Futures state
  const [futuresData, setFuturesData] = useState([]);
  const [futuresHeaders, setFuturesHeaders] = useState([]);
  const [fPageNo, setFPageNo] = useState(1);
  const [fTotalPages, setFTotalPages] = useState(1);
  const [isFuturesLoading, setIsFuturesLoading] = useState(false);

  // Options state
  const [optionsData, setOptionsData] = useState([]);
  const [optionsHeaders, setOptionsHeaders] = useState([]);
  const [oPage, setOPage] = useState(1);
  const [oTotalPages, setOTotalPages] = useState(1);
  const [isOptionsLoading, setIsOptionsLoading] = useState(false);

  const fetchSpotTransactions = async (page = 1) => {
    setIsSpotLoading(true);
    try {
      const historyObj = {
        pageNo: page,
        noOfItemsPerPage: 20,
        uuid: localStorage.getItem("uuid"),
        timeSpan,
        transactionType: "all",
      };

      const res = await axios.post(
        WEBSERVICE + "transaction/getUserAllTransaction",
        JSON.stringify(historyObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      if (res.data?.error?.error_data !== 0) {
        alert(res.data.error.error_msg || "Something went wrong");
      } else {
        const txns = res.data.userTransactionsResult || [];
        const total = res.data.totalCount || 0;
        const mappedData = txns.map((txn) => {
          const dateTime = txn.transactionTimestamp?.split(".")[0] || "";
          const tradeAssetAmount = txn.tradeAssetAmount;
          let statusText = "Pending",
            statusColor = "orange";
          if (txn.status === 1) {
            statusText = "Confirmed";
            statusColor = "green";
          } else if (txn.status === 2) {
            statusText = "Declined";
            statusColor = "red";
          }
          return {
            timestamp: dateTime,
            transactionId: txn.orderid || txn.transactionId,
            tradeAssetAmount,
            description: txn.description,
            action: txn.action,
            asset: txn.currency?.toUpperCase() || txn.baseCurrency || "-",
            status: statusText,
            statusColor,
          };
        });
        setSpotData(mappedData);
        setTotalPages(Math.ceil(total / 20));
      }
    } catch (err) {
      alert("SESSION TIMED OUT. LOGIN AGAIN");
      console.error(err);
    }
    setIsSpotLoading(false);
  };

  const fetchFuturesTransactions = async (page = 1) => {
    setIsFuturesLoading(true);
    try {
      const payload = {
        no_of_items_per_page: 20,
        page_no: page,
        uuid: localStorage.getItem("uuid"),
      };

      const res = await axios.post(
        WEBSERVICE + "/fTrade/userAllTransactions",
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      if (res.data.statuscode !== "0") {
        setFuturesData(res.data.transactionHistory || []);
        setFuturesHeaders(res.data.header || []);
        setFTotalPages(Math.ceil((res.data.totalRows || 0) / 20));
      } else {
        alert(res.data.message || "Error fetching futures transactions");
      }
    } catch (error) {
      alert("SESSION TIMED OUT. LOGIN AGAIN");
      console.error(error);
    }
    setIsFuturesLoading(false);
  };

  const checkCurrency = (text) => {
    return text?.trim().split(" ")[0].replace(/"/g, "");
  };

  const fetchOptionsTransactions = async (page = 1) => {
    setIsOptionsLoading(true);
    try {
      const payload = {
        no_of_items_per_page: 20,
        page_no: page,
        uuid: localStorage.getItem("uuid"),
      };

      const res = await axios.post(
        WEBSERVICE + "/optionsTrade/userAllTransactions",
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      if (res.data.statuscode !== "0") {
        setOptionsData(res.data.transactionHistory || []);
        setOptionsHeaders(res.data.header || []);
        setOTotalPages(Math.ceil((res.data.totalRows || 0) / 20));
      } else {
        alert(res.data.message || "Error fetching options transactions");
      }
    } catch (error) {
      alert("SESSION TIMED OUT. LOGIN AGAIN");
      console.error(error);
    }
    setIsOptionsLoading(false);
  };

  const handleOpenInvoiceModal = async (txnId) => {
    try {
      const response = await axios.post(
        "https://accounts.paybito.com/api/transaction/tradingInvoice",
        { transactionId: txnId },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
          },
        }
      );

      const data = response.data?.tradeInvoice;
      if (data) {
        const curr = localStorage.getItem("tradingFeesCurrency");
        const [counter, base] = data.assetPair.split("-");

        const tnxCurrency = data?.txnCharge.includes(curr);

        setInvoiceData({
          action: data.action,
          assetPair: data.assetPair,
          tradeQty: `${data.tradeQty} ${counter}`,
          tradePrice: `${data.tradePrice} ${base}`,
          value: `${data.value} ${base}`,
          txnCharge: `${data.txnCharge} ${tnxCurrency ? "" : base}`,
          gst: `${parseFloat(data.gst)} ${base} (₹${parseFloat(
            data.gstInInr
          ).toFixed(2)})`,
          tds: `${parseFloat(data.tdsCharge)} ${base} (₹${parseFloat(
            data.tdsInInr
          ).toFixed(2)})`,
          totalValue: `${data.totalValue} ${base}`,
          transactionTimestamp: data.transactionTimestamp,
        });
        setModalOpen(true);
      }
    } catch (error) {
      console.error("Failed to fetch invoice:", error);
      alert("Failed to fetch invoice details");
    }
  };

  useEffect(() => {
    fetchSpotTransactions(pageNo);
  }, [pageNo, timeSpan]);

  useEffect(() => {
    if (mainTab === "futures") fetchFuturesTransactions(fPageNo);
  }, [mainTab, fPageNo]);

  useEffect(() => {
    if (mainTab === "options") fetchOptionsTransactions(oPage);
  }, [mainTab, oPage]);

  const handletabchange = (value) => {
    setTimeSpan(value);
  };

  const accent = btncolor || "#1976d2";

  return (
    <Box sx={pageWrapper}>
      {/* ── Hero Banner ── */}
      <Box
        sx={{
          ...heroBanner,
          background: `linear-gradient(135deg, ${alpha(accent, 0.95)} 0%, ${alpha(accent, 0.75)} 100%)`,
        }}
      >
        <Box sx={heroContent}>
          <Box sx={heroIconBadge}>
            <HistoryOutlinedIcon sx={{ fontSize: 28, color: "#fff" }} />
          </Box>
          <Box>
            <Typography sx={heroTitle}>Transaction History</Typography>
            <Typography sx={heroSubtitle}>
              View all your Spot, Futures &amp; Options transactions
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* ── Main Card ── */}
      <Box sx={mainCard}>
        {/* Tabs */}
        <Box sx={tabsBar}>
          <Tabs
            value={mainTab}
            onChange={(e, val) => setMainTab(val)}
            textColor="inherit"
            TabIndicatorProps={{ style: { backgroundColor: accent, height: 3, borderRadius: 2 } }}
            sx={{
              minHeight: 48,
              "& .MuiTab-root": {
                textTransform: "none",
                fontWeight: 600,
                fontSize: "0.88rem",
                color: "var(--text-color)",
                opacity: 0.6,
                minHeight: 48,
                gap: 0.5,
              },
              "& .Mui-selected": { opacity: 1, color: "var(--text-color)" },
            }}
          >
            <Tab value="spot" icon={<ShowChartOutlinedIcon sx={{ fontSize: 18 }} />} iconPosition="start" label="Spot" />
            {brokerMarkets?.isFutures === 1 && (
              <Tab value="futures" icon={<TimelineOutlinedIcon sx={{ fontSize: 18 }} />} iconPosition="start" label="Futures" />
            )}
            {brokerMarkets?.isOptions === 1 && (
              <Tab value="options" icon={<BarChartOutlinedIcon sx={{ fontSize: 18 }} />} iconPosition="start" label="Options" />
            )}
          </Tabs>
        </Box>

        {/* ══ Spot Tab ══ */}
        <TabPanel value={mainTab} index="spot">
          <Box sx={tabFilterRow}>
            <Typography sx={tabSectionTitle}>Spot Transactions</Typography>
            <ActionButton
              options={FilterLabel}
              active={timeSpan}
              onChange={handletabchange}
              btnColor={accent}
            />
          </Box>

          {isSpotLoading ? (
            <Box sx={skeletonTable}>
              {[...Array(6)].map((_, idx) => (
                <Skeleton key={idx} variant="rectangular" height={44} sx={{ borderRadius: "8px", mb: 1 }} />
              ))}
            </Box>
          ) : (
            <>
              <DataTable columns={columns}>
                {spotData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6} sx={{ border: 0, py: 6 }}>
                      <Box sx={emptyState}>
                        <InboxOutlinedIcon sx={emptyIcon} />
                        <Typography sx={emptyText}>No transactions found</Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : (
                  spotData
                    ?.sort((a, b) => new Date(b.transactionDate) - new Date(a.transactionDate))
                    ?.map((row, idx) => (
                      <TableRow key={idx} sx={modernTableRow}>
                        <TableCell sx={modernCell}>{row.timestamp}</TableCell>
                        <TableCell sx={modernCell}>{row.transactionId}</TableCell>
                        <TableCell sx={{ ...modernCell, wordBreak: "break-all" }}>{row.description}</TableCell>
                        <TableCell sx={modernCell}>
                          {row.action === "Buy" || row.action === "Sell" ? (
                            <Box display="flex" alignItems="center" gap={1}>
                              <Typography variant="body2" sx={{ color: "var(--text-color)" }}>{row.action}</Typography>
                              <IconButton
                                size="small"
                                sx={invoiceIconBtn(accent)}
                                onClick={() => handleOpenInvoiceModal(row.transactionId)}
                              >
                                <ReceiptLongIcon sx={{ fontSize: 16 }} />
                              </IconButton>
                            </Box>
                          ) : (
                            <Typography variant="body2" sx={{ color: "var(--text-color)" }}>{row.action}</Typography>
                          )}
                        </TableCell>
                        <TableCell sx={modernCell}>
                          {checkCurrency(row.tradeAssetAmount) === row.asset ? "" : row.asset}{" "}
                          {row.tradeAssetAmount}
                        </TableCell>
                        <TableCell sx={modernCell}>
                          <Box
                            component="span"
                            sx={{
                              ...statusBadge,
                              backgroundColor:
                                row.statusColor === "green"
                                  ? "rgba(34,197,94,0.12)"
                                  : row.statusColor === "red"
                                  ? "rgba(239,68,68,0.12)"
                                  : "rgba(251,191,36,0.12)",
                              color:
                                row.statusColor === "green"
                                  ? "#22c55e"
                                  : row.statusColor === "red"
                                  ? "#ef4444"
                                  : "#f59e0b",
                            }}
                          >
                            {row.status}
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))
                )}
              </DataTable>
              <Box sx={paginationWrap}>
                <Pagination
                  count={totalPages}
                  page={pageNo}
                  onChange={(e, val) => setPageNo(val)}
                  sx={paginationStyle(accent)}
                />
              </Box>
            </>
          )}
        </TabPanel>

        {/* ══ Futures Tab ══ */}
        {brokerMarkets?.isFutures === 1 && (
          <TabPanel value={mainTab} index="futures">
          <Box sx={tabFilterRow}>
            <Typography sx={tabSectionTitle}>Futures Transactions</Typography>
          </Box>

          {isFuturesLoading ? (
            <Box sx={skeletonTable}>
              {[...Array(6)].map((_, idx) => (
                <Skeleton key={idx} variant="rectangular" height={44} sx={{ borderRadius: "8px", mb: 1 }} />
              ))}
            </Box>
          ) : (
            <>
              <DataTable columns={futuresHeaders}>
                {futuresData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={futuresHeaders.length || 12} sx={{ border: 0, py: 6 }}>
                      <Box sx={emptyState}>
                        <InboxOutlinedIcon sx={emptyIcon} />
                        <Typography sx={emptyText}>No futures transactions found</Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : (
                  futuresData
                    ?.sort((a, b) => new Date(b.transactionDate) - new Date(a.transactionDate))
                    ?.map((txn, idx) => (
                      <TableRow key={idx} sx={modernTableRow}>
                        <TableCell sx={modernCell}>{txn.transactionId}</TableCell>
                        <TableCell sx={modernCell}>{txn.transactionDate}</TableCell>
                        <TableCell sx={modernCell}>{txn.description}</TableCell>
                        <TableCell sx={modernCell}>{txn.transactionType}</TableCell>
                        <TableCell sx={modernCell}>{txn.debit !== 0 ? txn.debit : "-"}</TableCell>
                        <TableCell sx={modernCell}>{txn.credit !== 0 ? txn.credit : "-"}</TableCell>
                        <TableCell sx={modernCell}>{txn.operationMode}</TableCell>
                        <TableCell sx={modernCell}>{txn.leverage !== 0 ? `${txn.leverage}X` : "-"}</TableCell>
                        <TableCell sx={modernCell}>{txn.contractName}</TableCell>
                        <TableCell sx={modernCell}>-</TableCell>
                        <TableCell sx={modernCell}>{txn.intCharge !== 0 ? txn.intCharge : "-"}</TableCell>
                        <TableCell sx={modernCell}>{txn.amount !== 0 ? txn.amount : "-"}</TableCell>
                      </TableRow>
                    ))
                )}
              </DataTable>
              <Box sx={paginationWrap}>
                <Pagination
                  count={fTotalPages}
                  page={fPageNo}
                  onChange={(e, val) => setFPageNo(val)}
                  sx={paginationStyle(accent)}
                />
              </Box>
            </>
          )}
          </TabPanel>
        )}

        {/* ══ Options Tab ══ */}
        {brokerMarkets?.isOptions === 1 && (
          <TabPanel value={mainTab} index="options">
          <Box sx={tabFilterRow}>
            <Typography sx={tabSectionTitle}>Options Transactions</Typography>
          </Box>

          {isOptionsLoading ? (
            <Box sx={skeletonTable}>
              {[...Array(6)].map((_, idx) => (
                <Skeleton key={idx} variant="rectangular" height={44} sx={{ borderRadius: "8px", mb: 1 }} />
              ))}
            </Box>
          ) : (
            <>
              <DataTable columns={optionsHeaders}>
                {optionsData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={optionsHeaders.length || 12} sx={{ border: 0, py: 6 }}>
                      <Box sx={emptyState}>
                        <InboxOutlinedIcon sx={emptyIcon} />
                        <Typography sx={emptyText}>No options transactions found</Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : (
                  optionsData
                    ?.sort((a, b) => new Date(b.transactionDate) - new Date(a.transactionDate))
                    ?.map((list, idx) => (
                      <TableRow key={idx} sx={modernTableRow}>
                        <TableCell sx={modernCell}>{list.transactionId}</TableCell>
                        <TableCell sx={modernCell}>{new Date(list.transactionDate).toLocaleString()}</TableCell>
                        <TableCell sx={modernCell}>{list.description}</TableCell>
                        <TableCell sx={modernCell}>{list.transactionType}</TableCell>
                        <TableCell sx={modernCell}>{list.debit !== 0 ? list.debit : "-"}</TableCell>
                        <TableCell sx={modernCell}>{list.credit !== 0 ? list.credit : "-"}</TableCell>
                        <TableCell sx={modernCell}>{list.operationMode}</TableCell>
                        <TableCell sx={modernCell}>{list.leverage !== 0 ? `${list.leverage}X` : "-"}</TableCell>
                        <TableCell sx={modernCell}>{list.contractName?.toUpperCase()}</TableCell>
                        <TableCell sx={modernCell}>{list.txnCharge !== 0 ? list.txnCharge : "-"}</TableCell>
                        <TableCell sx={modernCell}>{list.intCharge !== 0 ? list.intCharge : "-"}</TableCell>
                        <TableCell sx={modernCell}>{list.amount !== 0 ? list.amount : "-"}</TableCell>
                      </TableRow>
                    ))
                )}
              </DataTable>
              <Box sx={paginationWrap}>
                <Pagination
                  count={oTotalPages}
                  page={oPage}
                  onChange={(e, val) => setOPage(val)}
                  sx={paginationStyle(accent)}
                />
              </Box>
            </>
          )}
          </TabPanel>
        )}
      </Box>

      {/* ── Invoice Dialog ── */}
      <Dialog
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        PaperProps={{ sx: modernDialogPaper }}
      >
        <DialogTitle sx={modernDialogTitle}>
          <Box sx={dialogTitleText}>
            <ReceiptLongIcon sx={{ fontSize: 20, color: accent }} />
            <Typography sx={{ fontWeight: 700, fontSize: "1rem", color: "var(--text-color)" }}>
              Trading Invoice
            </Typography>
          </Box>
          <IconButton sx={dialogCloseBtn} onClick={() => setModalOpen(false)}>
            <CloseIcon sx={{ fontSize: 18 }} />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={modernDialogContent}>
          {invoiceData && (
            <Stack spacing={0.5} mt={1}>
              {Object.entries(invoiceData).map(([label, value]) => (
                <Box key={label} sx={modernInvoiceRow}>
                  <Typography sx={invoiceRowLabel}>
                    {label.replace(/([A-Z])/g, " $1").toUpperCase()}
                  </Typography>
                  <Typography sx={invoiceRowValue}>{value}</Typography>
                </Box>
              ))}
            </Stack>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
}

// ─────────────────────────────────────────────
//  Style constants
// ─────────────────────────────────────────────

const pageWrapper = {
  px: { xs: 2, md: 4 },
  py: { xs: 2, md: 3 },
  backgroundColor: "var(--body-color)",
  minHeight: "100vh",
};

const heroBanner = {
  borderRadius: "18px",
  px: { xs: 3, md: 4 },
  py: { xs: 3, md: 3.5 },
  mb: 3,
  position: "relative",
  overflow: "hidden",
  "&::after": {
    content: '""',
    position: "absolute",
    right: -40,
    top: -40,
    width: 200,
    height: 200,
    borderRadius: "50%",
    background: "rgba(255,255,255,0.07)",
    pointerEvents: "none",
  },
};

const heroContent = {
  display: "flex",
  alignItems: "center",
  gap: 2,
  position: "relative",
  zIndex: 1,
};

const heroIconBadge = {
  width: 52,
  height: 52,
  borderRadius: "14px",
  background: "rgba(255,255,255,0.18)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

const heroTitle = {
  fontSize: { xs: "1.25rem", md: "1.5rem" },
  fontWeight: 700,
  color: "#fff",
  lineHeight: 1.2,
};

const heroSubtitle = {
  fontSize: "0.82rem",
  color: "rgba(255,255,255,0.78)",
  mt: 0.4,
};

const mainCard = {
  backgroundColor: "var(--body-color-less)",
  borderRadius: "16px",
  border: "1px solid rgba(128,128,128,0.12)",
  overflow: "hidden",
};

const tabsBar = {
  px: 2,
  pt: 1,
  borderBottom: "1px solid rgba(128,128,128,0.12)",
  backgroundColor: "var(--body-color-less)",
};

const tabFilterRow = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: 1.5,
  mb: 2.5,
  px: 0.5,
};

const tabSectionTitle = {
  fontSize: "0.95rem",
  fontWeight: 700,
  color: "var(--text-color)",
  letterSpacing: "0.01em",
};

const skeletonTable = { px: 1 };

const modernTableRow = {
  backgroundColor: "var(--body-color-less2)",
  "&:hover": { backgroundColor: "var(--body-color-less)", transition: "background 0.15s" },
  "& td": { border: 0, borderBottom: "1px solid rgba(128,128,128,0.07)" },
};

const modernCell = {
  color: "var(--text-color)",
  fontSize: "0.82rem",
  py: 1.2,
  px: 1.5,
};

const statusBadge = {
  display: "inline-block",
  px: 1.2,
  py: 0.35,
  borderRadius: "20px",
  fontSize: "0.75rem",
  fontWeight: 600,
  letterSpacing: "0.02em",
};

const emptyState = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 1.5,
  py: 2,
};

const emptyIcon = {
  fontSize: 48,
  color: "var(--text-color)",
  opacity: 0.25,
};

const emptyText = {
  fontSize: "0.88rem",
  color: "var(--text-color)",
  opacity: 0.45,
};

const paginationWrap = {
  display: "flex",
  justifyContent: "center",
  pt: 2,
  pb: 1,
};

const paginationStyle = (accent) => ({
  "& .MuiPaginationItem-root": {
    color: "var(--text-color)",
    borderRadius: "8px",
  },
  "& .Mui-selected": {
    backgroundColor: `${accent} !important`,
    color: "#fff",
  },
});

const invoiceIconBtn = (accent) => ({
  backgroundColor: alpha(accent, 0.15),
  color: accent,
  borderRadius: "7px",
  padding: "5px",
  "&:hover": { backgroundColor: alpha(accent, 0.28) },
});

// Dialog styles
const modernDialogPaper = {
  backgroundColor: "var(--popupbody-color)",
  backgroundImage: "none",
  borderRadius: "16px",
  minWidth: { xs: "92vw", sm: 420 },
  maxWidth: 480,
  border: "1px solid rgba(128,128,128,0.15)",
};

const modernDialogTitle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  px: 3,
  py: 2,
  backgroundColor: "var(--popupheader-color)",
  borderBottom: "1px solid rgba(128,128,128,0.12)",
};

const dialogTitleText = {
  display: "flex",
  alignItems: "center",
  gap: 1,
};

const dialogCloseBtn = {
  color: "var(--text-color)",
  opacity: 0.6,
  "&:hover": { opacity: 1, backgroundColor: "rgba(128,128,128,0.12)" },
};

const modernDialogContent = {
  px: 3,
  py: 2,
  backgroundColor: "var(--popupbody-color)",
};

const modernInvoiceRow = {
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: 2,
  px: 1.5,
  py: 1.1,
  borderRadius: "9px",
  backgroundColor: "var(--body-color-less2)",
  mb: 0.5,
};

const invoiceRowLabel = {
  fontSize: "0.72rem",
  fontWeight: 600,
  color: "var(--text-color)",
  opacity: 0.55,
  minWidth: 130,
  letterSpacing: "0.04em",
  pt: 0.1,
};

const invoiceRowValue = {
  fontSize: "0.82rem",
  fontWeight: 600,
  color: "var(--text-color)",
  textAlign: "right",
  flex: 1,
  wordBreak: "break-word",
};
